import { render, staticRenderFns } from "./SwitchTenant.vue?vue&type=template&id=0b59792b"
import script from "./SwitchTenant.vue?vue&type=script&lang=ts"
export * from "./SwitchTenant.vue?vue&type=script&lang=ts"
import style0 from "./SwitchTenant.vue?vue&type=style&index=0&id=0b59792b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports